<template>
  <VBtn
    :to="to"
    :href="href"
    :target="target"
    :rel="rel"
    :outline="outline"
    :filled="filled"
    :flat="flat"
    :title="title"
    :disabled="disabled"
    :class="['icon-btn', btnClassName]"
    @click="emitClick"
  >
    <span
      :class="[
        'icon-btn-ui',
        variationClassName,
        {
          'icon-btn-ui--with-label': label || $slots.default,
          'icon-btn-ui--outline': outline,
          'icon-btn-ui--flat': flat,
        },
      ]"
    >
      <span v-if="prependIconClassName" class="icon-btn-ui__icon icon-btn-ui__icon--prepend">
        <i :class="prependIconClassName" />
      </span>
      <slot>
        <span v-if="label" class="icon-btn-ui__label">
          {{ label }}
        </span>
      </slot>
      <span v-if="appendIconClassName" class="icon-btn-ui__icon icon-btn-ui__icon--append">
        <i :class="appendIconClassName" />
      </span>
    </span>
  </VBtn>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  // Components
  import VBtn from '~/misc/v-btn';

  export default defineComponent({
    name: 'IconBtn',
    components: {
      VBtn,
    },
    props: {
      to: {
        type: [Object, String],
        default: null,
      },
      href: {
        type: String,
        default: undefined,
      },
      target: {
        type: String,
        default: undefined,
      },
      rel: {
        type: String,
        default: undefined,
      },
      filled: {
        type: Boolean,
        default: true,
      },
      outline: {
        type: Boolean,
        default: false,
      },
      flat: {
        type: Boolean,
        default: false,
      },
      prependIconClassName: {
        type: String,
        default: '',
      },
      appendIconClassName: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      variationClassName: {
        type: String,
        default: undefined,
      },
      btnClassName: {
        type: String,
        default: undefined,
      },
    },
    emits: ['click'],
    methods: {
      emitClick() {
        this.$emit('click');
      },
    },
  });
</script>
